import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";

import Select2 from "../../../../components/common/select/Select2";
import Input from "../../../../components/common/input/Input";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import DatePicker2 from "../../../../components/common/datepicker/DatePicker2";
import { Field } from "redux-form";
import { required, date } from "../../../../utils/forms/validators";
import styles from "./FilterBox.scss";

const dateVal = date("Please enter a valid Date.");

const CATEGORIES = [
  { id: 1, value: "Status" },
  { id: 2, value: "Metro Area" },
  { id: 3, value: "Approved Date" },
  { id: 4, value: "Last Login Date" },
  { id: 5, value: "Skill Category" },
  { id: 6, value: "Skill" },
  { id: 7, value: "Filled References" },
  { id: 8, value: "Referral Type" },
  { id: 9, value: "Level" },
  { id: 10, value: "Industry" },
  { id: 11, value: "Signed Up Date" },
  { id: 12, value: "Full Time Availability" }
];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  getSkillsByCategory() {
    let allSkills = [];
    this.props.skillsOptions.forEach(skill => {
      allSkills = allSkills.concat(skill.skills);
    });

    const category = this.props.selectedSkillCategory[
      this.props.selectedSkillCategory.length - 1
    ];
    if (!category || category < 0)
      return allSkills.map(skill => ({ ...skill, value: skill.name }));
    const filtered = this.props.skillsOptions.filter(s => s.id == category);
    if (!filtered || filtered.length <= 0) return [];

    return filtered[0].skills.map(skill => ({ ...skill, value: skill.name }));
  }

  renderStatus() {
    const [, ...statusOptions] = this.props.statusOptions;

    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.status_id`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={statusOptions}
      />
    );
  }

  renderLocation() {
    return (
      <Field
        name={`${this.props.inputName}.location`}
        placeholder="Criteria"
        component={Typeahead}
        onSearch={query => this.props.onSearchCities(query)}
        isLoading={this.props.isLoadingCities}
        options={this.props.cities}
        isAsync={true}
        minLength={3}
        allowNew={false}
        labelKey="description"
        valueKey="id"
        selected={this.props.selectedLocation}
        icon="map-marker"
      />
    );
  }

  renderApprovedDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.approved_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.approved_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderLastLoginDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.last_login_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.last_login_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderSignedUpDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.signed_up_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.signed_up_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderNumberOfPitches() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.total_pitches_min`}
            placeholder="From"
            component={Input}
            validate={required}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.total_pitches_max`}
            placeholder="To"
            component={Input}
            validate={required}
          />
        </Col>
      </div>
    );
  }

  renderNumberOfSows() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.total_sow_min`}
            placeholder="From"
            component={Input}
            validate={required}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.total_sow_max`}
            placeholder="To"
            component={Input}
            validate={required}
          />
        </Col>
      </div>
    );
  }

  renderSkillsCategories() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.skill_category`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.skillsCategoriesOptions.map(skill => ({
          ...skill,
          value: skill.name
        }))}
      />
    );
  }

  renderSkills() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.skill`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.getSkillsByCategory()}
      />
    );
  }

  renderCommuteCities() {
    const options = [
      ...this.props.commuteCitiesOptions,
      {
        id: -1,
        value: "No Value"
      }
    ];

    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.metro_area`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={options}
      />
    );
  }

  renderReferralTypes() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.referral_type`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.referralTypesOptions}
      />
    );
  }

  renderLevels() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.level`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.levelsOptions}
      />
    );
  }

  renderIndustries() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.industry`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.industriesOptions}
      />
    );
  }

  renderNumberOfReferences() {
    const options = [
      {
        id: 0,
        value: "None"
      },
      {
        id: 1,
        value: 1
      },
      {
        id: 2,
        value: "2 or more"
      }
    ];

    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.filled_references`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={options}
      />
    );
  }

  renderFullTimeAvailability() {
    const options = [
      {
        id: 1,
        value: "Yes"
      },
      {
        id: 0,
        value: "No"
      },
      {
        id: -1,
        value: "Unselected"
      }
    ];

    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.full_time_job`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={options}
      />
    );
  }

  renderCriteria() {
    switch (this.state.selectedCategory) {
      case 1:
        return this.renderStatus();
      case 2:
        return this.renderCommuteCities();
      case 3:
        return this.renderApprovedDate();
      case 4:
        return this.renderLastLoginDate();
      case 5:
        return this.renderSkillsCategories();
      case 6:
        return this.renderSkills();
      case 7:
        return this.renderNumberOfReferences();
      case 8:
        return this.renderReferralTypes();
      case 9:
        return this.renderLevels();
      case 10:
        return this.renderIndustries();
      case 11:
        return this.renderSignedUpDate();
      case 12:
        return this.renderFullTimeAvailability();
      default:
        return null;
    }
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Category"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderCriteria()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/users/components/FilterBox.js